<div fxLayout="row mt-5" class="container" fxFlex="100" fxLayoutAlign="space-between" [formGroup]="formGroup">
  <!-- First column -->
  <div class="column" fxLayout="column" fxFlex="24">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Company' | translate }}</mat-label>
      <input
        matInput
        formControlName="company"
        [placeholder]="'Company' | translate"
        [matAutocomplete]="autocompleteCompany"
        [errorStateMatcher]="matcher"
        tabindex="1"
        />
        <mat-autocomplete #autocompleteCompany="matAutocomplete" [displayWith]="displayValue">
          @for (company of companies$ | async; track company) {
            <mat-option [value]="company"> {{ company.Name }} </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'FirstName' | translate }}</mat-label>
        <input matInput type="text" formControlName="firstName" tabindex="5" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'AbsenceStartDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" autocomplete="date" tabindex="9" />
        <mat-datepicker-toggle [for]="startDatePicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Second column -->
    <div class="column" fxLayout="column" fxFlex="24">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Employer' | translate }}</mat-label>
        <input matInput formControlName="employer" placeholder="{{ 'Employer' | translate }}" [matAutocomplete]="autocompleteEmployer" tabindex="2" />
        <mat-autocomplete #autocompleteEmployer="matAutocomplete" [displayWith]="displayValue">
          @for (employer of employers$ | async; track employer) {
            <mat-option [value]="employer">
              {{ employer.Name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'AbsenceType' | translate }}</mat-label>
        <mat-select formControlName="absenceTypeId" multiple tabindex="6">
          @for (absenceType of absenceTypes$ | async; track absenceType) {
            <mat-option [value]="absenceType.Id">
              {{ absenceType.Name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'AbsenceEndDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" autocomplete="date" tabindex="10" />
        <mat-datepicker-toggle [for]="endDatePicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Third column -->
    <div class="column" fxLayout="column" fxFlex="24">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
        <input
          matInput
          formControlName="employerObject"
          placeholder="{{ 'EmployerObject' | translate }}"
          [matAutocomplete]="autocompleteEmployerObject"
          tabindex="3"
          />
          <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
            @for (employerObject of employerObjects$ | async; track employerObject) {
              <mat-option [value]="employerObject">
                {{ employerObject.Name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'Status' | translate }}</mat-label>
          <mat-select formControlName="statusId" multiple tabindex="6">
            @for (absenceStatus of absenceStatuses$ | async; track absenceStatus) {
              <mat-option [value]="absenceStatus.Id">
                {{ absenceStatus.Name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'AppliesToSubordinates' | translate }}</mat-label>
          <input type="text" formControlName="subordinates" [value]="getSelectedItemsNames()" matInput
            [matAutocomplete]="auto">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option disabled>Zależnosć w strukturze</mat-option>
              <mat-tree [dataSource]="dataSource | async" [treeControl]="treeControl">
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                  <button mat-icon-button disabled></button>
                  <mat-checkbox
                    [disabled]="checklistSelection?.selected?.length >= 3 && !checklistSelection.isSelected(node)"
                    [checked]="checklistSelection.isSelected(node)"
                    (change)="subortinatesLeafItemSelectionToggle(node)">
                  </mat-checkbox>
                  {{node.name}}
                </mat-tree-node>
                <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                  <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
                    <mat-icon class="mat-icon-rtl-mirror">
                      {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                  </button>
                  <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)"
                    (change)="subortinatesItemSelectionToggle(node)">
                  </mat-checkbox>
                  {{node.name}}
                </mat-tree-node>
              </mat-tree>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <!-- Fourth column -->
        <div class="column" fxLayout="column" fxFlex="24">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'LastName' | translate }}</mat-label>
            <input matInput type="text" formControlName="lastName" tabindex="4" />
          </mat-form-field>

          <mat-form-field appearance="outline" *hasPermission="isSentToExteralSystemPermissions">
            <mat-label>{{ 'IsSentToExteralSystem' | translate }}</mat-label>
            <mat-select formControlName="absenceSyncStatusId" multiple tabindex="8">
              @for (absenceSyncStatus of absenceSyncStatuses$ | async; track absenceSyncStatus) {
                <mat-option [value]="absenceSyncStatus.Id">
                  {{ absenceSyncStatus.Name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
